'use client';

import React, { useContext } from 'react';
import { GlobalContext } from '$context/global-context';
import SignInMobile from './signIn.mobile';
import SignInWeb from './signIn.web';
export default function SignInContent() {
  const {
    state
  } = useContext(GlobalContext);
  const isMobile = state.screen.isMobile;
  return <>{isMobile ? <SignInMobile /> : <SignInWeb />}</>;
}